import React, { useState } from "react";
import college from "../../Assets/svg/college logo.svg";

function EduProfile(props) {
  // const item = props.item;
  // const [item, setItem] = useState({});

  return (
    <div className="edu-tab">
      {props?.item?.mentorEducationDetails?.map((item, index) => (
        <div className="edu">
          <img src={college} alt="college" />
          <div className="edu-right">
            <div className="set-title">{item?.degree}</div>
            <div className="college">{item?.university}</div>
            <div className="degree">{item?.academicProgram}</div>
            {/* <div className="date">Jan 2019 - Mar 2023</div> */}
          </div>
        </div>
      ))}
    </div>
  );
}

export default EduProfile;
